import React from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { BsBoxArrowUpRight, BsPatchCheckFill } from 'react-icons/bs'
import './CertificationsSection.css'

const certifications = [
  {
    title: 'Adobe Certified Master - Adobe Experience Manager Sites Architect',
    level: 'Master',
    issuer: 'Adobe Credly Verified',
    image:
      'https://images.credly.com/size/680x680/images/f8bb518f-e604-4531-83f3-52a47ba5b72d/Adobe_Certified_Master_Experience_Cloud_products_Digital_Badge.png',
    link: 'https://www.credly.com/badges/3d1996ad-9108-4e11-aef3-80389be35cb4',
  },
  {
    title:
      'Adobe Certified Expert - Adobe Experience Manager Sites Lead Developer',
    level: 'Expert',
    issuer: 'Adobe Credly Verified',
    image:
      'https://images.credly.com/size/680x680/images/3a78e715-3ded-4b43-9ba3-52710c06327a/Adobe_Certified_Expert_Experience_Cloud_products_Digital_Badge.png',
    link: 'https://www.credly.com/badges/da79ba21-bbcc-4982-9473-40eb6e75d816',
  },
]

function CertificationsSection() {
  return (
    <div className="section-container">
      <Container>
        <h2 className="section-title">Certifications &amp; Badges</h2>
        <Row className="justify-content-center g-4">
          {certifications.map((certification, index) => (
            <Col key={index} xs={12} md={6} lg={5}>
              <Card className="modern-card cert-card h-100">
                <div className="cert-badge-top">
                  <span className="cert-status-tag">
                    <BsPatchCheckFill className="cert-check-icon" aria-hidden="true" />
                    {certification.issuer}
                  </span>
                  <span className="cert-level-tag">{certification.level}</span>
                </div>

                <div className="cert-image-container">
                  <img
                    className="certification-image"
                    src={certification.image}
                    alt={certification.title}
                    loading="lazy"
                    decoding="async"
                    referrerPolicy="no-referrer"
                    onError={e => {
                      e.currentTarget.onerror = null
                      e.currentTarget.src =
                        process.env.PUBLIC_URL + '/assets/images/logo512.jpeg'
                    }}
                  />
                </div>

                <Card.Body className="d-flex flex-column text-center pt-2">
                  <Card.Title className="cert-card-title flex-grow-1">
                    {certification.title}
                  </Card.Title>
                  <div className="mt-3">
                    <a
                      href={certification.link}
                      className="modern-btn cert-verify-btn"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`View certification credential for ${certification.title}`}
                    >
                      <span>Verify Credential</span>
                      <BsBoxArrowUpRight className="ms-1" aria-hidden="true" />
                    </a>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  )
}

export default CertificationsSection
